const Joi = require("joi");

const calenderSchema = (data) => {
  const schema = Joi.object({
    eventType: Joi.string().valid("single", "recurrence").messages({
      "any.only": "Invalid event format.",
    }),

    // committee: Joi.string().trim().required().messages({
    //   "string.empty": "Invalid Committee",
    //   "any.required": "Invalid Committee",
    // }),

    title: Joi.string().trim().max(150).required().messages({
      "string.empty": "Please enter Title.",
      "any.required": "Please enter Title.",
      "string.max": "Title must not exceed 150 characters",
    }),

    description: Joi.string().trim().max(2500).optional().allow("").messages({
      "string.max": "Description must not exceed 2500 characters",
    }),

    committee: Joi.string()
      .trim()
      .when(Joi.ref("publicEvent"), {
        is: true,
        then: Joi.string().trim().optional().allow(null),
        otherwise: Joi.string().trim().required().messages({
          "string.empty": "Invalid Committee",
          "any.required": "Invalid Committee",
        }),
      }),

    start: Joi.date().required().messages({
      "date.base": "Start date must be a valid date.",
      "any.required": "Please select start date.",
    }),

    end: Joi.date().greater(Joi.ref("start")).required().messages({
      "date.base": "End date must be a valid date.",
      "date.greater": "End date must be greater than start date.",
      "any.required": "Please select end date.",
    }),
    location: Joi.string()
      .lowercase()
      .valid("virtual", "physical", "hybrid")
      .required()
      .messages({
        "any.only": "Invalid location format.",
        "any.required": "Location is required.",
      }),

    url: Joi.string()
      .trim()
      .when("location", {
        is: "virtual",
        then: Joi.required().messages({
          "string.empty": "Please enter URL",
          "any.required": "Please enter URL",
        }),
        otherwise: Joi.when("location", {
          is: "hybrid",
          then: Joi.required().messages({
            "string.empty": "Please enter URL",
            "any.required": "Please enter URL",
          }),
          otherwise: Joi.optional().allow(""),
        }),
      }),

    // address: Joi.string()
    //   .trim()
    //   .when("location", {
    //     is: "physical",
    //     then: Joi.required().messages({
    //       "string.empty": "Please enter Address",
    //       "any.required": "Please enter Address",
    //     }),
    //     otherwise: Joi.when("location", {
    //       is: "hybrid",
    //       then: Joi.required().messages({
    //         "string.empty": "Please enter Address",
    //         "any.required": "Please enter Address",
    //       }),
    //       otherwise: Joi.optional().allow(""),
    //     }),
    //   }),
    address: Joi.string()
      .trim()
      .when("location", {
        is: "physical",
        then: Joi.string().max(500).required().messages({
          "string.empty": "Please enter Address",
          "any.required": "Please enter Address",
          "string.max": "Address must not exceed 500 characters",
        }),
        otherwise: Joi.when("location", {
          is: "hybrid",
          then: Joi.string().max(500).required().messages({
            "string.empty": "Please enter Address",
            "any.required": "Please enter Address",
            "string.max": "Address must not exceed 500 characters",
          }),
          otherwise: Joi.optional().allow(""),
        }),
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = calenderSchema;
